import { bankApi } from "./authenticatedAxios";
import { responseDataHandler } from "./responseHandler";
import { concatApiQuery } from "../utils/strings";

export const getConversionRateApi = (fromCurrency, toCurrency) =>
  bankApi
    .get(concatApiQuery(`/currency/conversionRate`, { fromCurrency, toCurrency }))
    .then(({ data }) => responseDataHandler(data));
